import type { Personnel, PersonnelCategory } from '../personnel/types';

interface QueueInvitePersonnelInput {
    personnelId?: string;
    name: string;
    email: string;
    category?: unknown;
    rosterPersonId?: string;
}

interface QueueInvitePersonnelActions {
    personnel: Personnel[];
    addPersonnel: (member: Partial<Personnel>) => string;
    updateOperationalPersonnel: (id: string, updates: Partial<Personnel>) => void;
}

export function mapInviteCategoryToPersonnelCategory(category: unknown): PersonnelCategory {
    const normalized = typeof category === 'string' ? category.trim().toLowerCase() : '';
    if (normalized === 'cast') return 'cast';
    if (normalized === 'production') return 'production';
    return 'crew';
}

export function normalizeInviteEmail(email: string): string {
    return email.trim().toLowerCase();
}

export function queuePersonnelForInvite(
    actions: QueueInvitePersonnelActions,
    input: QueueInvitePersonnelInput,
    queuedBy?: string
): string | null {
    const name = input.name.trim();
    const email = input.email.trim();
    if (!name || !email) return null;

    const normalizedEmail = normalizeInviteEmail(email);
    const existing = actions.personnel.find((person) => input.personnelId && person.id === input.personnelId)
        ?? actions.personnel.find((person) => input.rosterPersonId && person.rosterPersonId === input.rosterPersonId)
        ?? actions.personnel.find((person) => person.email ? normalizeInviteEmail(person.email) === normalizedEmail : false);
    const inviteQueue = {
        status: 'queued' as const,
        queuedAt: new Date().toISOString(),
        ...(queuedBy ? { queuedBy } : {}),
    };
    const updates: Partial<Personnel> = {
        name,
        email,
        category: mapInviteCategoryToPersonnelCategory(input.category),
        rosterPersonId: input.rosterPersonId,
        inviteQueue,
    };

    if (existing) {
        actions.updateOperationalPersonnel(existing.id, updates);
        return existing.id;
    }

    return actions.addPersonnel(updates);
}
